import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import { Button, Message, Grid, Divider } from "semantic-ui-react";

import FormsInputsText from "../../inputs/text/forms_inputs_text";
import FormsInputsDropdown from "../../inputs/dropdown";
import AddUserSchema from "./validate";

const yesNoOptions = [
  { text: "Yes", value: "Y" },
  { text: "No", value: "N" },
];

class FormsUserAdd extends Component {
  state = {
    error: false,
    errorMessage: "",
    success: false,
  };
  renderFormSubmissionResult() {
    if (this.state.success === true) {
      return (
        <Message positive>
          <Message.Header>
            Admin user created successfully. A password setup email has been
            sent.
          </Message.Header>
        </Message>
      );
    }
    if (this.state.error === true) {
      return (
        <Message negative>
          <Message.Header>{this.state.errorMessage}</Message.Header>
        </Message>
      );
    }
  }
  render() {
    return (
      <Formik
        initialValues={{
          name: "",
          email: "",
          enableNewChatNotification: "Y",
        }}
        onSubmit={(values, actions) => {
          this.setState({ error: false, errorMessage: "", success: false });
          const { accessToken } = this.props.user;
          this.props.createNewAdminUser(
            { accessToken, data: values },
            (result, error) => {
              if (error) {
                actions.setSubmitting(false);

                const errorMessage =
                  (error.response &&
                    error.response.data &&
                    error.response.data.errorMessage) ||
                  "Password setup failed. Please try again.";

                this.setState({
                  error: true,
                  errorMessage,
                });
              }
              if (result) {
                actions.resetForm();
                actions.setSubmitting(false);
                this.setState({ success: true });
              }
            }
          );
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={AddUserSchema}
        render={({
          values,
          errors,
          status,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form style={{ padding: 20 }}>
            <Grid container columns={2}>
              <Grid.Column width={16}>
                <Divider horizontal>Add New Admin User</Divider>
              </Grid.Column>
              <Grid.Column>
                <Field
                  name="name"
                  label="Name"
                  component={FormsInputsText}
                  secondaryLabel=""
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name="email"
                  label="Email"
                  component={FormsInputsText}
                  secondaryLabel=""
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name="enableNewChatNotification"
                  label="Enable New Chat Notification"
                  options={yesNoOptions}
                  component={FormsInputsDropdown}
                  secondaryLabel=""
                />
              </Grid.Column>
              <Grid.Column width={16}>
                <Button
                  loading={isSubmitting}
                  type="submit"
                  primary
                  disabled={isSubmitting}
                  fluid
                  size="big">
                  Create New Admin User
                </Button>
              </Grid.Column>
              <Grid.Column width={16}>
                {this.renderFormSubmissionResult()}
              </Grid.Column>
            </Grid>
          </Form>
        )}
      />
    );
  }
}

export default FormsUserAdd;
